"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeFilterElementsSearchBar = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
/**
 * This component displays a text field and calls onSearch callback when user types search text.
 *
 * @beta
 */
exports.AttributeFilterElementsSearchBar = function (props) {
    var onSearch = props.onSearch, searchString = props.searchString, isSmall = props.isSmall;
    return react_1.default.createElement(sdk_ui_kit_1.InvertableSelectSearchBar, { onSearch: onSearch, searchString: searchString, isSmall: isSmall });
};
//# sourceMappingURL=AttributeFilterElementsSearchBar.js.map